module.exports = __webpack_public_path__ + "6e05659ef1fd0f417f8b226859cf66e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/poly-bg/poly-bg-9.jpg
// module id = 398
// module chunks = 0